import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose, branch, renderComponent, lifecycle } from 'recompose';
import _ from 'lodash';
import {
  ListGroup,
  ListGroupItem,
  Glyphicon,
} from 'react-bootstrap';

import { queryGetAllUserMonthBonusesForUserMonthGQL } from '../graphql/allUserMonthBonusUsersApi';
import {
  getBonusMonth, getSupervisorId,
  getUserId,
} from '../selectors';
import { setUserId, setUserIdState } from '../actions';
import { APPROVED, FINALIZED } from '../constants';

/* eslint-disable react/no-unused-prop-types */
const propTypes = exact({
  allUserMonthBonusesForUserMonth: PropTypes.array,
  userId: PropTypes.number,
  setUserIdAction: PropTypes.func.isRequired,
  setUserIdStateAction: PropTypes.func.isRequired,

  supervisorId: PropTypes.number.isRequired,
  bonusMonth: PropTypes.string.isRequired,
});
/* eslint-enable react/no-unused-prop-types */

const AllUsersMonthBonusList = (props) => {
  const {
    allUserMonthBonusesForUserMonth,
    setUserIdAction,
    userId,
    setUserIdStateAction,
  } = props;

  const handleSelectUser = (item) => {
    const { user, state } = item;
    setUserIdAction(user.id);
    setUserIdStateAction(state);
  };

  const handleRenderListGroupItem = (item) => {
    const { user, state } = item;
    const { id, fullname } = user;
    const isActiveClass = (id === userId) ? 'active' : '';

    if (state === APPROVED) {
      return (
        <ListGroupItem
          className={`list-group-item ${isActiveClass} `}
          style={{ backgroundColor: 'rgb(167, 177, 251)' }}
          key={id}
          onClick={() => {
            return handleSelectUser(item);
          }}
        >
          {fullname}
          <Glyphicon glyph="ok" className="pull-right" style={{ verticalAlign: 'middle' }} />
        </ListGroupItem>
      );
    }

    if (state === FINALIZED) {
      return (
        <ListGroupItem
          className={`list-group-item ${isActiveClass} `}
          style={{ backgroundColor: 'lightgreen' }}
          key={id}
          onClick={() => {
            return handleSelectUser(item);
          }}
        >
          {fullname}
          <Glyphicon glyph="usd" className="pull-right" style={{ verticalAlign: 'middle' }} />
        </ListGroupItem>
      );
    }

    return (
      <ListGroupItem
        className={`list-group-item ${isActiveClass} `}
        key={id}
        onClick={() => {
          return handleSelectUser(item);
        }}
      >
        {fullname}
      </ListGroupItem>
    );
  };

  return (
    <ListGroup className="allUserList-scroll-bar">
      {allUserMonthBonusesForUserMonth.map((item) => {
        return handleRenderListGroupItem(item);
      })}
    </ListGroup>
  );
};


AllUsersMonthBonusList.propTypes = propTypes;


const mapStateToProps = (state) => {
  return {
    bonusMonth: getBonusMonth(state),
    supervisorId: getSupervisorId(state),
    userId: getUserId(state),
  };
};
const mapDispatchToProps = {
  setUserIdAction: setUserId,
  setUserIdStateAction: setUserIdState,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);


const withNoUsersMonthBonuses = branch(
  (props) => {
    return props.allUserMonthBonusesForUserMonth.length === 0;
  },
  renderComponent((props) => {
    return (
      <div className="panel-body" style={{ textAlign: 'center' }}>
        <h4>Empty</h4>
        <p className="text-muted">No Employee Bonuses to Review</p>
      </div>
    );
  }),
);

/* NOTE: Will always have allUserMonthBonusesForUserMonth list. Guarded above */
const withSelectUser = lifecycle({
  componentWillMount() {
    const {
      allUserMonthBonusesForUserMonth,
      setUserIdAction,
      userId,
      setUserIdStateAction,
    } = this.props;

    const currentIndex = _.findIndex(allUserMonthBonusesForUserMonth, (item) => {
      return (item.user.id === userId);
    });

    /* If current userId is not in the selected supervisor's list, and there's items in the list */
    if (currentIndex === -1) {
      setUserIdAction(allUserMonthBonusesForUserMonth[0].user.id);
      setUserIdStateAction(allUserMonthBonusesForUserMonth[0].state);
    }
  },
  /* When you reselect a supervisor */
  componentWillReceiveProps(nextProps) {
    const { allUserMonthBonusesForUserMonth, setUserIdAction, setUserIdStateAction } = nextProps;

    /* See if current userId is in the nextProps list of all users */
    const currentIndex = _.findIndex(allUserMonthBonusesForUserMonth, (item) => {
      return (item.user.id === this.props.userId);
    });

    /* If current userId is not in the selected supervisor's users list, *
    * and there's items in the list */
    if (currentIndex === -1) {
      setUserIdAction(allUserMonthBonusesForUserMonth[0].user.id);
      setUserIdStateAction(allUserMonthBonusesForUserMonth[0].state);
    }
  },
});

const enhance = compose(
  withRedux,
  queryGetAllUserMonthBonusesForUserMonthGQL,
  withNoUsersMonthBonuses,
  withSelectUser,
);

export default enhance(AllUsersMonthBonusList);
